import {
  getData, putData, postData,
} from './index';
import {
  ERROR_USER,
  GET_NEWS,
  GET_NEWS_ALL,
  GET_NEW,
  POST_NEW,
  PUT_NEW,
  SET_TOAST,
} from './types';

const addDays = (days) => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date;
};

/** Published news for visualisation (last 31 days). */
export async function getNewsAction(dispatch) {
  const url = '/news';
  let news;
  await getData(ERROR_USER, url, dispatch, true).then((response) => {
    const minDate = addDays(-31);
    const now = new Date();
    news = response.news
      .filter((n) => n.status === 'published')
      .filter((n) => {
        const articleDate = new Date(n.date);
        return articleDate <= now && articleDate >= minDate;
      });
  });
  dispatch({
    type: GET_NEWS,
    payload: news,
  });
}

/** All news for gestion (drafts + published). */
export async function getAllNewsAction(dispatch) {
  const url = '/news';
  let news;
  await getData(ERROR_USER, url, dispatch, true).then((response) => {
    news = response.news;
  });
  dispatch({
    type: GET_NEWS_ALL,
    payload: news,
  });
}

export async function getNewAction(dispatch, id) {
  const url = `/news/${id}`;
  let news;
  await getData(ERROR_USER, url, dispatch, true).then((response) => {
    news = response.news;
  });
  dispatch({
    type: GET_NEW,
    payload: news,
  });
}

export async function postNewAction(dispatch, data) {
  const url = '/news';
  let news;
  await postData(POST_NEW, ERROR_USER, url, dispatch, data, true).then((response) => {
    news = response.news;
  });
  dispatch({
    type: SET_TOAST,
    payload: { type: 'success', message: "L'actualité a été créée" },
  });
  dispatch({
    type: POST_NEW,
    payload: news,
  });
  return news;
}

export async function putNewAction(dispatch, id, data) {
  const url = `/news/${id}`;
  let news;
  await putData(PUT_NEW, ERROR_USER, url, dispatch, data, true).then((response) => {
    news = response.news;
  });
  dispatch({
    type: SET_TOAST,
    payload: { type: 'success', message: "L'actualité a été modifiée" },
  });
  dispatch({
    type: PUT_NEW,
    payload: news,
  });
  return news;
}
